import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

let maskScene: any = null,
    titleScene: any = null;
export default function O() {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const { locale = 'us' } = useRouter();
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (maskScene) AniContainer.removeScene(maskScene);
                if (titleScene) AniContainer.removeScene(titleScene);

                const clientH = (window.innerHeight || 0) * 0.6;
                const startH = Math.min(clientH, 450);
                maskScene = AniContainer.create({
                    triggerElement: '.dpu-detail-O',
                    triggerHook: 1,
                    offset: startH,
                    duration: 300, //window.innerHeight * 2,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (maskScene) AniContainer.removeScene(maskScene);
                if (titleScene) AniContainer.removeScene(titleScene);
            };
        }
    }, []);

    return (
        <>
            {/* <EfSpec /> */}
            <section id="dpu-detail-O" className={`dpu-detail-O dpu-detail-section ${css['dpu-detail-O']}`}>
                <div className={`sticky-box${textEnter ? ' textEnter' : ''}`}>
                    <div className="img-box">
                        <EFPicture
                            src={
                                isEU
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751182756914/pc_Safe%20and%20Reliable.png'
                                    : '/responsive/picture/delta-pro-ultra/launch/15.jpg'
                            }
                            srcPad={
                                isEU
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751182756746/m_Safe%20and%20Reliable.png'
                                    : '/responsive/picture/delta-pro-ultra/launch/15_768.jpg'
                            }
                            srcMobile={
                                isEU
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751182756746/m_Safe%20and%20Reliable.png'
                                    : '/responsive/picture/delta-pro-ultra/launch/15_768.jpg'
                            }
                            alt={t('secO_title')}
                        />
                        <div className="mask"></div>
                        <div className="title-box">
                            <h2 className="title">{t('secO_title')}</h2>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
